<template>
  <div style="width: 100%">
    <Breadcrumb></Breadcrumb>
    <div class="table-body">
      <div style="overflow:hidden;">
        <div style="margin: 0 0 8px 0;" class="left">
        <el-button type="primary" size="small" @click="handleAdd"
          >创建角色</el-button
        >
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadList"
        />
      </div>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        class="border"
        @selection-change="rowSelectionChange"
      >
        <!-- header-cell-class-name="table-header" -->
        <el-table-column
          prop="roleName"
          label="角色名称"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="描述"
          align="center"
        ></el-table-column>
        <el-table-column prop="userName" label="关联成员" align="center">
          <template slot-scope="scope">
            <span :key="name" v-for="(name, index) in scope.row.userName">
              {{ name }}
              <span v-if="index != scope.row.userName.length - 1">,</span>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="状态" align="center" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" style="font-weight: bold;">正常</span>
            <span v-else-if="scope.row.status == 1" style="font-weight: bold;color: red">停用</span>
            <span v-else>未知</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="110">
          <template slot-scope="scope">
            <el-button @click="handleUpdate(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="handleRemove(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadList"
      />
      <!-- 创建角色dialog -->
      <!--        <div class="create_role_dialog">-->
      <el-dialog :close-on-click-modal="false"  
        :title="title"
        :visible.sync="dialogFormVisible"
        append-to-body
      >
        <el-form
          :model="form"
          ref="form"
          class="create_role_form"
          :rules="rules"
        >
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              size="small"
              v-model="form.roleName"
              placeholder="请输入角色名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="权限字符" prop="roleKey" v-show="false">
            <el-input
              size="small"
              v-model="form.roleKey"
              placeholder="请输入权限字符"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色顺序" prop="roleSort" v-show="false">
            <el-input-number
              size="small"
              v-model="form.roleSort"
              controls-position="right"
              :min="0"
            />
          </el-form-item>
          <el-form-item label="状态" v-show="false">
            <el-radio-group v-model="form.status">
              <el-radio
                v-for="dict in statusOptions"
                :key="dict.dictValue"
                :label="dict.dictValue"
                >{{ dict.dictLabel }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="描述">
            <el-input
              size="small"
              v-model="form.remark"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色权限" class="item-menu">
            <el-tree
              :data="menuData"
              node-key="id"
              ref="menu"
              show-checkbox
              :props="defaultProps"
              icon-class="el-icon-circle-plus"
            ></el-tree>
          </el-form-item>

          <el-form-item label="店铺权限" v-show="false">
            <!--                        <el-tree :data="storeData" node-key="id" ref="shop" show-checkbox :props="defaultProps"></el-tree>-->
            <el-tabs
              v-model="activeTabPane"
              style="height: 150px"
              type="border-card"
            >
              <el-tab-pane
                :key="item.dictValue"
                :label="item.dictLabel"
                :name="index + ''"
                v-for="(item, index) in storeData"
              >
                <el-checkbox-group
                  v-model="checkList"
                  @change="shopSelectChange"
                >
                  <el-checkbox
                    :label="child.id"
                    v-for="child in item.children"
                    :key="child.id"
                    >{{ child.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="medium"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitForm" size="medium"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!--        </div>-->
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  listRole,
  getStoreList,
  addRole,
  delRole,
  getRole,
  updateRole,
} from "@/api/system/role"
import {
  treeselect as menuTreeSelect,
  roleMenuTreeselect,
} from "@/api/system/menu"
import { roleShopSelect } from "@/api/system/shop"
export default {
  components: { Breadcrumb },
  data() {
    return {
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      activeTabPane: 0,
      total: 0,
      tableData: [],
      dialogFormVisible: false,
      title: "",
      form: {},
      menuData: [],
      storeData: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      defaultProps: {
        children: "children",
        label: "label",
        value: "id",
      },
      ids: [],
      //电商平台编码（1688 -- 01 ，速卖通 -- 02 等等）
      platformCodes: [],
      // 状态数据字典
      statusOptions: [],
      checkList: [],
      // 表单校验
      rules: {
        roleName: [
          { required: true, message: "角色名称不能为空", trigger: "blur" },
        ],
        roleKey: [
          { required: true, message: "权限字符不能为空", trigger: "blur" },
        ],
        roleSort: [
          { required: true, message: "角色顺序不能为空", trigger: "blur" },
        ],
      },
      roleUser: [],
    }
  },
  created() {
    this.loadList()
    this.loadMenuTree()
    this.getDicts("s_plat_code").then((response) => {
      this.platformCodes = response.data
      this.loadShopTree()
    })
    this.getDicts("sys_normal_disable").then((response) => {
      this.statusOptions = response.data
    })
  },
  methods: {
    handleAdd() {
      this.reset()
      let date = new Date()
      this.form.roleKey = this.$store.state.user.name + date.getTime()
      this.dialogFormVisible = true
      this.title = "添加角色"
    },
    handleUpdate(row) {
      let that = this
      this.reset()
      this.form = row
      let roleId = row.roleId
      const roleMenu = this.getRoleMenuTreeselect(roleId)
      this.getRoleShopSelect(roleId)
      getRole(roleId).then((response) => {
        this.form = response.data
        this.dialogFormVisible = true
        this.$nextTick(() => {
          roleMenu.then((res) => {
            that.$refs.menu.setCheckedKeys(res.checkedKeys)
          })
        })
        this.title = "编辑角色"
      })
    },
    //表格行选择事件
    rowSelectionChange(selection) {
      this.ids = selection.map((item) => item.roleId)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    /** 根据角色ID查询菜单树结构 */
    getRoleMenuTreeselect(roleId) {
      return roleMenuTreeselect(roleId).then((response) => {
        this.menuData = response.menus
        return response
      })
    },
    /**  根据角色ID获取店铺id*/
    getRoleShopSelect(roleId) {
      roleShopSelect(roleId).then((res) => {
        this.checkList = res.data
      })
    },
    //获取当前账号创建的角色
    loadList() {
      this.startLoading()
      listRole(this.queryParams)
        .then((res) => {
          if (res.code == 200) {
            this.total = res.total
            this.tableData = res.rows
          }
          this.endLoading()
        })
        .catch((err) => {this.endLoading()})
    },
    loadMenuTree() {
      menuTreeSelect()
        .then((res) => {
          this.menuData = res.data
        })
        .catch((err) => {})
    },
    //获取商家各平台下店铺
    loadShopTree() {
      // let that = this
      // getStoreList()
      //   .then((res) => {
      //     that.storeData = that.filterStoreData(res.data)
      //   })
      //   .catch((err) => {})
    },
    // 商铺选择事件
    shopSelectChange(val) {
      this.checkList = val
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (this.form.roleId != undefined) {
          this.form.menuIds = this.getMenuAllCheckedKeys()
          this.form.shopIds = this.checkList
          updateRole(this.form).then((response) => {
            if (response.code === 200) {
              this.msgSuccess("修改成功")
              this.dialogFormVisible = false
              this.loadList()
            }
          })
        } else {
          this.form.menuIds = this.getMenuAllCheckedKeys()
          this.form.shopIds = this.checkList
          addRole(this.form)
            .then((response) => {
              if (response.code === 200) {
                this.msgSuccess("新增成功")
                this.dialogFormVisible = false
                this.loadList()
              }
            })
            .catch((err) => {})
        }
      })
    },
    handleRemove(row) {
      const roleIds = row.roleId || this.ids
      if (row.userName && row.userName.length) {
        this.$message.error("被引用中的角色无法被删除")
        return false
      }
      this.$confirm(
        '是否确认删除角色编号为"' + roleIds + '"的数据项?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function() {
          return delRole(roleIds)
        })
        .then(() => {
          this.loadList()
          this.msgSuccess("删除成功")
        })
        .catch(function() {})
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 半选中的菜单节点
      let halfCheckedKeys = this.$refs.menu.getHalfCheckedKeys()
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys()
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys)
      return checkedKeys
    },
    // 所有店铺节点数据
    getShopAllCheckedKeys() {
      // 目前被选中的菜单节点
      return this.$refs.shop.getCheckedKeys(true, false)
    },
    // 表单重置
    reset() {
      if (this.$refs.menu != undefined) {
        this.$refs.menu.setCheckedKeys([])
      }
      this.checkList = []
      this.form = {
        roleId: undefined,
        roleName: null,
        roleKey: null,
        roleSort: 0,
        status: "0",
        menuIds: [],
        shopIds: [],
        remark: null,
      }
      this.resetForm("form")
    },
    filterStoreData(data) {
      let cloneData = JSON.parse(JSON.stringify(data))
      let treeData = this.platformCodes.filter((father) => {
        let branchArr = cloneData.filter(
          (child) => father.dictValue == child.platNo
        )
        father.label = father.dictLabel
        father.value = father.dictValue
        branchArr.filter((store) => {
          store.label = store.shopName
          store.id = store.shopId
        })
        branchArr.length > 0 ? (father.children = branchArr) : "" //给父级添加一个children属性，并赋值
        return father
      })
      return treeData.filter((item) =>
        item.hasOwnProperty("children") ? item : null
      )
    },
  },
}
</script>

<style scope>
.create_role_form {
  margin: 15px 15px 0 15px;
}
.create_role_form .el-form-item {
  display: flex;
  margin-bottom: 15px !important;
}
.create_role_form .el-form-item .el-form-item__label {
  width: 100px;
  font-weight: 700;
}
.create_role_form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
}

.roleList .el-table--fit {
  border-right: 0 !important;
  border-left: 0 !important;
  border-bottom: 0 !important;
  margin: 3px 0;
}
.roleList .el-table__row td {
  padding: 10px 0;
}

.roleList .el-table__row td:nth-child(7) .el-button {
  float: left;
  font-size: 14px;
}
.roleList .button-interval {
  width: 1px;
  height: 12px;
  float: left;
  background: #4934b2;
  margin: 11px 12px 0;
}

.el-dialog-window {
  overflow: hidden;
}
.el-dialog-window .el-dialog {
  margin-top: 8vh !important;
}
.el-dialog-window .el-dialog__body {
  margin-right: 15px;
}
.el-dialog-window .item-menu .el-form-item__content {
  border: 1px solid #b2b3b6;
  border-radius: 5px;
  padding: 1px;
  overflow: auto;
  height: 19.85rem;
}
.el-dialog-window .el-tabs--border-card {
  border: 1px solid #b2b3b6;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  border-radius: 5px;
  padding: 1px;
}

.el-dialog-window .el-tree-node__expand-icon.expanded {
  transform: rotate(0deg) !important;
}
.el-dialog-window .el-icon-circle-plus:before {
  font-size: 16px;
}
.el-dialog-window .expanded.el-icon-circle-plus:before {
  content: "\e7a2" !important;
}
</style>
